import { EntitySelectorsFactory } from '@ngrx/data';

import { createSelector } from '@ngrx/store';
import { ActividadGrupoEspecie } from '@rpe/registro-personas-empresas-lib';
import { selectAllActividadesGrupoEspecie } from '../entity-actividades-grupo-especie/entity-actividades-grupo-especie.selectors';
import { selectAllActividades } from '../entity-actividades/entity-actividades.selectors';
import { selectCurrentEmpresa } from '../../empresas/entity-mis-empresas/entity-current-empresa.selectors';
import { GrupoEspecie } from './grupos-especie.model';

export const gruposEspecieSelectors =
  new EntitySelectorsFactory().create<GrupoEspecie>('GrupoEspecie');

export const selectAllGruposEspecie = gruposEspecieSelectors.selectEntities;

export const selectGruposEspeciesByTipoActividad = (tipoActividad: number) =>
  createSelector(
    selectAllGruposEspecie,
    selectAllActividades,
    selectCurrentEmpresa,
    selectAllActividadesGrupoEspecie,
    (gruposEspecies, actividades, currentEmpresa, actividadesGrupoEspecie) => {
      const actividad = actividades.find(
        (a) =>
          a.entidad_productiva_id == currentEmpresa.id &&
          a.tipo_actividad_id === tipoActividad
      );
      
      let actividadesGrupoEspecieFilterActividad: ActividadGrupoEspecie[];
      let retGruposEspecies: GrupoEspecie[] = [];
      if (actividad) {
        actividadesGrupoEspecieFilterActividad = actividadesGrupoEspecie.filter(
          (age) => age.actividad_id == actividad.id
        );
        
        if (actividadesGrupoEspecieFilterActividad?.length > 0) {
          gruposEspecies.forEach((ge) => {
            if (
              actividadesGrupoEspecieFilterActividad.find(
                (a) => a.grupo_especie_id == ge.id
              )
            ) {
              retGruposEspecies.push(ge);
            }
          });
        }
      }
      
      return retGruposEspecies;
    }
  );
export const selectActividadesFromCurrentEmpresa = createSelector(
  selectAllActividades,
  selectCurrentEmpresa,
  (actividades, currentEmpresa) =>
    actividades.filter((a) => a.entidad_productiva_id == currentEmpresa.id)
);
